<template>
  <div class="works-show">
    <div v-if="item" class="show-content">
      <div class="user-title">
        <div class="img">
          <img :src="'http://shopxmhs.oss-cn-beijing.aliyuncs.com/8ed87202305271831213652.png'" alt="">  
        </div>
        <div class="title-content">
          <div class="name"> {{ item.name }} </div>
          <div class="time"> {{ item.time }} </div>
        </div>
      </div>
      <div v-if="item.title" class="title-text">
        {{ item.title }}
      </div>
      <div class="eval-box">
        <div v-for="(item_eval, index_eval) in item.evalPic" :key="'eval-item'+index_eval" class="eval-item" :class="{ evalItems: item.evalPic.length-2 > 0, videoClass:  getFlieType(item_eval) === 3}">
          <img v-if="getFlieType(item_eval) === 1" :src="item_eval" @click="showPicture(item.evalPic, item.visitHistory, item.id, index_eval)" alt="">
          <div v-if="getFlieType(item_eval) === 3" class="video-box" ref="videoBox"  @click="showVideo(item_eval, item.visitHistory, item.id)">
            <video :src="item_eval" @play="onVideoPlay(item.visitHistory, item.id)" @pause="videoPause" @ended="endPlay" @loadeddata="videoLoad" muted ref="video"/>
            <img v-show="pause" src="@assets/images/common/pause-state.png" alt="">
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import { getFlieType } from '@common'

  export default {
    name: 'WorkEvaluate',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: null
      },
    },
    data() {
      return {
        pause: true,
      }
    },
    methods: {
      getFlieType(url) { //检测文件类型
        let type = getFlieType(url);
          if (type === 'image') { //图片
            return 1;
          }else if (type === 'radio') { //音乐
            return 2;
          }else if (type === 'video') { //视频
            return 3;
          }else {
            return 0;
          }
      },
      showPicture(path, history, id, index) { //展示图片 //emit
        this.$emit('showPicture', { path, history, id, index });
      },
      showVideo(path, history, id) { //展示图片 //emit
        this.$emit('showVideo', { path, history, id });
      },
      onVideoPlay(history, id) { //播放器播放 //emit
        this.$emit("onVideoPlay", { history, id });
        this.pause = false;
      },
      videoLoad() { //video渲染完成 设置宽高
        let elem = this.$refs.video[0];
        if (elem.offsetWidth < elem.offsetHeight) {
          this.$refs.videoBox[0].style.width = '60%';
        }else {
          this.$refs.videoBox[0].style.width = '100%';
        }
      },
      videoPause() { //播放器暂停
        this.pause = true;
      },
      endPlay() { //播放结束
        this.pause = true;
      }
    },
    watch: {
      pause: {
        handler(newValue) {
          if (newValue) {
            this.$refs.video[0].pause();
          }else {
            this.$refs.video[0].play();
          }
        },
        deep: true,
      }
    }
  }
</script>

<style scoped>
  .user-title {
    display: flex;
  }
      .img img {
        width: 1rem;
        height: 1rem;
        border-radius: 20%;
      }
    .title-content {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
    }
      .name {
        margin-left: 0.2rem;
        font-size: 0.32rem;
        font-weight: 550;
        color: #5d5b5b;
        letter-spacing: 0.05rem;
      }
      .time {
        color: #6f6f6f;
        margin-top: 33px;
      }
  .title-text {
    padding-left: 0.1rem;
    margin-top: 10px;
  }
  .eval-box {
    width: 100%;
  /* padding: 0px 0px 0px 15px; */
  margin: 10px 0 10px;
  border: 10px solid black;
  box-shadow: 3px 3px 5px #5e5e5e, 3px 3px 5px #949494 inset;
  min-height: 100px;
  }
    .eval-item {
      flex: 1;
      width: 100%;
      margin: 0.02rem 0.04rem;
      height: 4rem;
      overflow: hidden;
    }
    .evalItems {
      width: calc(33.33% - 0.08rem);
      flex: none;
      height: auto;
    }
    .videoClass {
      height: auto;
    }
      .eval-item img, .eval-item video {
        width: 100%;
      }
        .video-box {
          position: relative;
          width: 60%;
        }
          .eval-item .video-box video {
            width: 100%;
          }
          .video-box img {
            position: absolute;  
            width: 0.8rem;
            height: 0.8rem;
            left: calc(50% - 0.4rem);
            top: calc(50% - 0.4rem);
          }
</style>